import React from "react";
import AdminAllContacts from "../../Components/Admin/AdminAllContacts";
import SideBar from "../../Components/Admin/SideBar";

const AdminAllContactsPage = ()=>{
    return (
      <AdminAllContacts />
    )
}

export default AdminAllContactsPage;